<template>
  <div class="central_content">
    <div style="display: flex; flex-wrap: wrap">
      <div class="search_list">
        <Input
          v-model="parameter.orderId"
          @input="  parameter.pageNow = 1;
            getData()"
          search
          placeholder="订单号"
          style="width: auto;margin-left: 20px;"
        />
      </div>
      <div class="search_list">
        <Input
          v-model="parameter.phone"
          @input="parameter.pageNow = 1;
            getData()"
          search
          placeholder="手机号"
          style="width: auto;margin-left: 20px;"
        />
      </div>
      <div class="search_list">
        <div class="text">状态:</div>
        <Select
          v-model="parameter.state"
          @on-change="
            parameter.pageNow = 1;
            getData();
          "
          class="select"
        >
          <Option :value="0">未达标</Option>
          <Option :value="1">已达标</Option>
          <Option :value="2">已发货</Option>
        </Select>
      </div>
    </div>
    <Table
      border
      class="table_style"
      :columns="columns"
      :data="userList.list"
      :highlight-row="true"
    >
      <template slot-scope="{ row, index }" slot="giftImg">
        <img style="width: 100px" :src="row.giftImg" alt srcset />
      </template>
      <template slot-scope="{ row, index }" slot="state">
        <div v-if="row.state == 0">未达标</div>
        <div v-if="row.state == 1">已达标</div>
        <div v-if="row.state == 2">已发货</div>
      </template>

      <template slot-scope="{ row, index }" slot="config">
        <Button
          v-if="row.state==1"
          @click="
            upData = row;
            title = '发货';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
        >发货</Button>

        <Button
          @click="
            upData = row;
            title = '删除';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
        >删除</Button>
      </template>
    </Table>

    <Modal width="800" v-model="Show" :title="title" @on-ok="UaorderShip">
      <div v-if="title == '删除'">删除</div>

      <div v-else>发货</div>
    </Modal>
    <Page :total="userList.total" @on-change="switchover" />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      userList: { list: [] },
      title: "",
      upData: {},
      Show: false,
      parameter: {
        pageNow: 1
      },
      pageNow1: 1,
      columns: [
        {
          title: "id",
          className: "fontcolor",
          align: "center",
          key: "id"
        },
        {
          title: "订单号",
          className: "fontcolor",
          align: "center",
          key: "orderId"
        },
        {
          title: "礼品名称",
          className: "fontcolor",
          align: "center",
          key: "giftName"
        },

        {
          title: "礼品图片",
          align: "center",
          className: "fontcolor",
          slot: "giftImg"
        },
        {
          title: "收货人手机号",
          className: "fontcolor",
          align: "center",
          key: "phone"
        },
        {
          title: "收货人姓名",
          className: "fontcolor",
          align: "center",
          key: "name"
        },
        {
          title: "收货人地址",
          className: "fontcolor",
          align: "center",
          key: "address"
        },
        {
          title: "状态",
          align: "center",
          slot: "state",
          className: "fontcolor"
        },
        {
          title: "创建时间",
          className: "fontcolor",
          align: "center",
          key: "createTime"
        },
        {
          title: "修改时间",
          className: "fontcolor",
          align: "center",
          key: "modifyTime"
        },
        {
          title: "操作",
          className: "fontcolor",
          align: "center",
          slot: "config",
          width: 180,
          fixed: "right"
        }
      ]
    };
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    handleSuccess(res, file) {
      this.upData.img = res.data[0].path;
      this.$forceUpdate();
    },

    UaorderShip() {
      if (this.title == "发货") {
        api.InformationGiftDelivery(this.upData.id).then(res => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }

      if (this.title == "删除") {
        api.InformationGiftDel(this.upData.id).then(res => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
    },

    switchover(pageNow) {
      this.parameter.pageNow = pageNow;
      this.getData();
    },

    getData() {
      api.InformationGiftQueryList(this.parameter).then(res => {
        this.userList = res.body.data;
      });
    }
  }
};
</script>

<style scoped>
</style>